<template>
    <BaseModal @close="onCloseModal">
        <template v-slot:modalBody>
            <div class="create-modal">
                <div class="create-modal__section create-modal__title">
                    {{title}}
                </div>
                <div class="create-modal__section">
                    <BaseSelect
                        canSearch
                        isFullWidth
                        isRemoveOption
                        :options="loginInputHistoryBuffer"
                        :value="inputHistoryItemId"
                        searchPlaceholder="Введите значение"
                        defaultTitle="Введите логин пользователя"
                        @onSearchValue="onSearchLogin"
                        @check="onSelectLoginUser"
                        @onRemoveOption="onRemoveOption"
                    />
                </div>
                <div class="create-modal__section">
                    <TagsCreate
                        :isFullWidth="true"
                        :options="tags"
                        :enteredTags="enteredPointTags"
                        :value="tagsSelected"
                        :isOpenedDropdown="isOpenedTagsRequestDropdown"
                        @check="onSelectOfferTags"
                        @onRemoveTag="onRemoveTag"
                        @onClickCreate="
                            isOpenedTagsRequestDropdown =
                                !isOpenedTagsRequestDropdown
                        "
                    />
                </div>
                <div class="create-modal__section create-modal__actions">
                    <LinceButton
                        class="create-modal__action"
                        @click="onCloseModal"
                    >
                        Отменить
                    </LinceButton>
                    <LinceButton
                        :disabled="!isSendBtn"
                        :theme="'secondary'"
                        class="create-modal__action"
                        @click="send"
                    >
                        Отправить
                    </LinceButton>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '@/components/Base/BaseModal.vue';
import TagsCreate from "./TagsCreate.vue";
import BaseSelect from "../../../Base/BaseSelect.vue";
import ServiceInputStore from "../../../../services/ServicesInputStore/ServiceInputStore";

export default {
    name: 'CreateModal',
    components: {
        BaseModal,
        TagsCreate,
        BaseSelect
    },
    props: {
        title: {
            type: String,
            default: 'Создание предложения'
        },
        tags: {
            type: Array,
            default: () => ([])
        }
    },
    data: () => ({
        tagsSelected: [],
        loginUser: '',
        selectedTag: "",
        enteredPointTags: [],
        isOpenedTagsRequestDropdown: false,
        loginInputHistory: [],
        loginInputHistoryBuffer: []
    }),
    computed: {
        isSendBtn() {
            return String(this.loginUser) !== '';
        },

        inputHistoryItemId() {
            if (!this.loginUser){
                return null;
            }

            const index = this.loginInputHistoryBuffer.findIndex(item => item.value === this.loginUser);

            return index !== -1 ? this.loginInputHistoryBuffer[index].id : null;
        }
    },

    created() {
        this.fetchLoginInputHistory();
    },

    watch: {
        loginInputHistory(value) {
            this.loginInputHistoryBuffer = value;
        }
    },

    methods: {
        onCloseModal() {
            this.$emit('onCloseModal');
        },

        onSelectOfferTags(value) {
            this.isOpenedTagsRequestDropdown = false;

            if (this.enteredPointTags.includes(value)) return;
            this.selectedTag = value;
            this.enteredPointTags.push(value);
        },

        onRemoveTag(value) {
            this.enteredPointTags = this.enteredPointTags.filter(
                (item) => item !== value
            );
        },

        onInputLoginUser(loginUser = '') {
            this.loginUser = String(loginUser);
        },

        send() {
            this.$emit('send', this.loginUser, this.enteredPointTags);

            this.onSelectValue();
        },

        onSearchLogin(value){
            let found = this.loginInputHistory.filter(item => item.value.toLowerCase().indexOf(value.toLowerCase()) !== -1);

            if(found.length){
                this.loginInputHistoryBuffer = [...found];
                return;
            }

            this.loginInputHistoryBuffer = [{id: 0, value}];
        },

        async onRemoveOption(option) {
            const {id = 0} = option

            if(this.inputHistoryItemId === id){
                this.loginUser = '';
            }

            if(id === 0){
                this.loginInputHistoryBuffer = [...this.loginInputHistory];
                return;
            }

            try {
                await ServiceInputStore.delete(id);
                const newIndex = this.loginInputHistoryBuffer.findIndex(item => item.id === 0);
                const filteredItems = this.loginInputHistory.filter(item => item.id !== id);

                if (newIndex === -1) {
                    this.loginInputHistory = filteredItems;
                } else {
                    this.loginInputHistory = [this.loginInputHistoryBuffer[newIndex], ...filteredItems];
                }
            } catch (error) {
                this.onApiError(error);
            }
        },

        onSelectLoginUser(option) {
            this.loginUser = option.value;
        },

        async fetchLoginInputHistory() {
            try {
                const items = await ServiceInputStore.list('receiver_mail');
                this.loginInputHistory = [...items];
            }catch (e){
                this.onApiError(e)
            }
        },

        async onSelectValue() {
            if(!this.loginUser){
                return;
            }

            try {
                const item = await ServiceInputStore.select('receiver_mail', this.loginUser);
                const {id = null} = item;
                const loginInputHistory = [...this.loginInputHistory].filter(historyItem => historyItem.id !== id);
                this.loginInputHistory = [item, ...loginInputHistory];
            }catch (e){
                this.onApiError(e)
            }
        },

        onApiError(error) {
            this.$notify.addNotification({
                type: 'error',
                title: 'Ошибка',
                description: error.message,
                duration: Infinity,
                position: 'bottom-right'
            });

            this.isLoading = false
        }
    }
}
</script>

<style lang="scss" scoped>
    .create-modal {
        &__title {
            font-size: 20px;
            font-weight: 500;
        }

        &__section {
            &:not(:last-child) {
                margin-bottom: 20px;
            }
        }

        &__select {
            width: 100%;

            ::v-deep .select-preview {
                padding: 10px 20px;
            }
        }

        &__actions {
            display: flex;
            justify-content: end;
        }

        &__action {
            &:not(:last-child) {
                margin-right: 5px;
            }
        }
    }
</style>
